import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { router } from './router'
import App from './App.vue'
import { BootstrapVue3 } from 'bootstrap-vue-3'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import VueFeather from 'vue-feather'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import DatePicker from 'vue3-datepicker'

// Custom plugins
import { ToastPlugin } from '@/plugins/toast'
import { AlertPlugin } from '@/plugins/sweetalert'

// Custom directives
import { vTooltip } from '@/directives/tooltip'

// Layout Components
import LayoutHeader from '@/views/layouts/layout-header.vue'
import LayoutSidebar from '@/views/layouts/layout-sidebar.vue'
import IndexLoader from '@/views/layouts/index-loader.vue'

// Breadcrumb
import BreadcrumbIndex from '@/components/breadcrumb/breadcrumb-index.vue'

// Styles
import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/fontawesome.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import '@/assets/css/feather.css'
import '@/assets/scss/main.scss'

import swal from 'sweetalert2'
window.Swal = swal

const app = createApp(App)
const pinia = createPinia()

// Layout Components
app.component('layout-header', LayoutHeader)
app.component('layout-sidebar', LayoutSidebar)
app.component('index-loader', IndexLoader)

// Breadcrumb
app.component('breadcrumb-index', BreadcrumbIndex)

// Third-party components
app.component(VueFeather.name, VueFeather)
app.component('date-picker', DatePicker)

app.use(pinia)
app.use(router)
app.use(BootstrapVue3)
app.use(Antd)
app.use(VueSweetalert2)

// Custom notification plugins
app.use(ToastPlugin)
app.use(AlertPlugin)

// Register global directives
app.directive('tooltip', vTooltip)

app.mount('#app')
